import { render, staticRenderFns } from "./Rechte.vue?vue&type=template&id=2442e2c2&scoped=true"
import script from "./Rechte.vue?vue&type=script&lang=js"
export * from "./Rechte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442e2c2",
  null
  
)

export default component.exports